// extracted by mini-css-extract-plugin
export default {"background":"LayeredModalLayout_background__Mx9zd","dim":"LayeredModalLayout_dim__lbxIU"};